<template>
    <div class="search-location" v-loading-bar="isLoading">
        <!-- <i-loading v-show="isLoading"></i-loading> -->
        <div
            v-show="!isLoading && (!data || (!data.city && !data.zone && !data.hotel))"
            class="non-tips"
        >
            <i class="iconfont icon-warning"></i>
            {{$t('no_result')}}
        </div>
        <!-- <ul class="loading-bar">
            <li class="bar-item"></li>
            <li class="bar-item"></li>
            <li class="bar-item"></li>
        </ul>-->
        <!-- <loading-bar></loading-bar> -->
        <ul v-if="data">
            <li v-for="(item, i) in data.city" :key="'city' + i" class="city-level">
                <div class="list-item" @click="select(item)">
                    <i class="iconfont icon-location"></i>
                    <div class="main-text text-ellipsis">{{item.cityName}}</div>
                    <div class="sub-text text-ellipsis">{{item.countryName}}</div>
                </div>
            </li>
            <li v-for="(item, i) in data.zone" :key="'zone' + i" class="city-level">
                <div class="list-item" @click="select(item)">
                    <i class="iconfont icon-location"></i>
                    <div class="main-text text-ellipsis">{{item.areaName}}</div>
                    <div class="sub-text text-ellipsis">{{item.cityName}},{{item.countryName}}</div>
                </div>
            </li>
            <li v-for="(item, i) in data.hotel" :key="'hotel' + i" class="city-level">
                <div class="list-item" @click="select(item)">
                    <i class="iconfont icon-hotel"></i>
                    <div class="main-text text-ellipsis">{{item.hotelName}}</div>
                    <div class="sub-text text-ellipsis">{{item.cityName}},{{item.countryName}}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import ILoading from "@/views/AirTicket/components/Loading";
import LoadingBar from "@/components/loading/LoadingBar.vue";

export default {
    name: "searchHotel",
    components: {
        ILoading,
        LoadingBar
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        select(child) {
            let name = child.hotelName || child.areaName || child.cityName;
            // if (child.hotelItemCode) {
            //     /* 直接跳转酒店详情 */
            //     child.searchType = "hotel";
            //     this.$router.push({
            //         name: "HotelDetail",
            //         params: {
            //             id: child.hotelItemCode,
            //             city_code: child.cityCode
            //         }
            //     });
            // } else {
            //     child.searchType = "city";
            // }
            this.$emit("menu-select", name, child);
        }
    }
};
</script>

<style lang="scss" scoped>
.search-location {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 2048;
    width: 456px;
    max-height: 400px;
    min-height: 50px;
    overflow-y: auto;
    padding: 0 0 0 20px;
    background-color: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16),
        0px 2px 5px 0px rgba(0, 0, 0, 0.26);

    .non-tips {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 0;
        margin-bottom: -10px;
        text-shadow: none;
        font-weight: normal;
        color: #484848;

        i {
            color: #f5c230;
            margin-right: 5px;
        }
    }

    .list-item {
        position: relative;
        margin-left: -20px;
        padding: 10px 20px 10px 40px;
        color: #484848;
        border-bottom: 1px solid #eee;

        .iconfont {
            position: absolute;
            top: 50%;
            left: 10px;
            transform: translateY(-50%);
        }

        .main-text {
            font-size: 16px;
            line-height: 20px;
        }
        .sub-text {
            font-size: 12px;
            line-height: 16px;
            color: #767676;
        }
    }
    .list-item:hover {
        background-color: RGBA(0, 169, 186, 0.4);
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/SearchLocation.vue